import classNames from 'classnames';
import React from 'react';
import { Typography } from '../../foundations/typography';
import styles from './ProductPodCounter.module.scss';
var ProductPodCounter = function (_a) {
    var _b;
    var className = _a.className, productName = _a.productName, _c = _a.trolleyQuantity, amount = _c.amount, uomId = _c.uomId, recentlyAdded = _a.recentlyAdded, uoms = _a.uoms;
    var trolleyUom = Object.values(uoms).find(function (uom) { return uom.id === uomId; }) || { label: '' };
    var displayQuantity = "".concat(amount).concat(trolleyUom.label);
    var active = amount > 0;
    return (React.createElement("div", { className: classNames(className, styles.productPodCounter), "data-testid": "product-pod-counter-text" }, active && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.initialMessage, (_b = {}, _b[styles.added] = recentlyAdded, _b)) },
            React.createElement(Typography, { styleAs: "paragraphHeading" },
                displayQuantity,
                " added")),
        React.createElement("div", { className: styles.mainMessage },
            React.createElement(Typography, { styleAs: "paragraphHeading" },
                displayQuantity,
                " in trolley")),
        React.createElement("p", { className: styles.srAnnouncement, "aria-live": "polite", "data-testid": "counter-live-region" }, "Quantity of ".concat(productName, " in trolley: ").concat(displayQuantity))))));
};
ProductPodCounter.displayName = 'ProductPodCounter';
export default ProductPodCounter;
//# sourceMappingURL=ProductPodCounter.js.map